import { InternalParserError, ParserError } from "../errors";
import type { Table } from "../table";
import {
  parseFieldMessage,
  parseGroupMessage,
  parseSchemaMessage,
} from "./parse";
import type {
  Datenfeld,
  Datenfeldgruppe,
  Regel,
  SchemaContainer,
} from "./schema";

export class SchemaMessage {
  public readonly messageId: string;
  public readonly createdAt: Date;
  public readonly schemaContainer: SchemaContainer;

  constructor(
    messageId: string,
    createdAt: Date,
    schemaContainer: SchemaContainer,
  ) {
    this.messageId = messageId;
    this.createdAt = createdAt;
    this.schemaContainer = schemaContainer;
  }

  public static fromString(value: string): SchemaMessage {
    try {
      const { messageId, createdAt, schemaContainer } =
        parseSchemaMessage(value);

      return new SchemaMessage(messageId, createdAt, schemaContainer);
    } catch (error) {
      if (error instanceof InternalParserError) {
        throw new ParserError(error.message);
      }

      throw error;
    }
  }
}

export class GroupMessage {
  constructor(
    public messageId: string,
    public createdAt: Date,
    public root: string,
    public groups: Table<Datenfeldgruppe>,
    public fields: Table<Datenfeld>,
    public rules: Table<Regel>,
  ) {}

  public static fromString(value: string): GroupMessage {
    try {
      const { messageId, createdAt, root, groups, fields, rules } =
        parseGroupMessage(value);

      return new GroupMessage(
        messageId,
        createdAt,
        root,
        groups,
        fields,
        rules,
      );
    } catch (error) {
      if (error instanceof InternalParserError) {
        throw new ParserError(error.message);
      }

      throw error;
    }
  }
}

export class FieldMessage {
  constructor(
    public messageId: string,
    public createdAt: Date,
    public field: Datenfeld,
    public regeln: Table<Regel>,
  ) {}

  public static fromString(value: string): FieldMessage {
    try {
      const { messageId, createdAt, field, regeln } = parseFieldMessage(value);

      return new FieldMessage(messageId, createdAt, field, regeln);
    } catch (error) {
      if (error instanceof InternalParserError) {
        throw new ParserError(error.message);
      }

      throw error;
    }
  }
}
